import { Base_Url } from "../../BaseURL/BaseUrl";
import {
  getApiWithAuthorization,
  postApiWithAuthorization,
} from "../ApiMethods/ApiMethod";

const UserRoleUrl = `${Base_Url}/Admin`;

export const GetAdminList = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/GetAdminList`,
    params
  );
  return res;
};

export const AddUpdateAdmin = async (params) => {
  const res = await postApiWithAuthorization(
    `${UserRoleUrl}/AddUpdateAdmin`,
    params
  );
  return res;
};
export const GetAdminModel = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetAdminModel?AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const ChangeAdminStatus = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/ChangeAdminStatus?AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const DeleteAdmin = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/DeleteAdmin?AdminKeyID=${AdminKeyID}`
  );
  return res;
};

export const GetAdminLookupList = async (AdminKeyID) => {
  const res = await getApiWithAuthorization(
    `${UserRoleUrl}/GetAdminLookupList?AdminKeyID=${AdminKeyID}`
  );
  return res;
};
